import { router } from "expo-router";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Text, ScrollView, View, Pressable } from "react-native";
import { CheckBox } from "react-native-btr";
import Toast from "react-native-toast-message";
import { useDispatch } from "react-redux";

import Logo from "@/assets/logo.svg";
import Copyright from "@/components/Copyright";
import Loader from "@/components/Loader";
import Title from "@/components/Title";
import Button from "@/components/button/Button";
import ButtonLogout from "@/components/button/ButtonLogout";
import { setForm } from "@/context/actions/actions";

export default function Terms() {
  const [check, setCheck] = useState(false);
  const [checkThirdPartiesAgreement, setCheckThirdPartiesAgreement] =
    useState(false);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const bridgeUrl = "https://www.bridge.xyz/legal";

  const { handleSubmit, formState } = useForm({
    mode: "onChange",
  });

  const { isSubmitting } = formState;

  const onSubmit = async () => {
    if (check && checkThirdPartiesAgreement) {
      dispatch(setForm({ isAddIndividualFlow: false }));
      router.push("/documents");
    } else if (!check || !checkThirdPartiesAgreement) {
      Toast.show({
        type: "error",
        autoHide: false,
        props: {
          text1: t("common:toast.attention"),
          text2: t("onboarding/terms:warning"),
        },
      });
    }
  };

  function toggle() {
    setCheck(!check);
  }

  function toggleThirdPartiesAgreement() {
    setCheckThirdPartiesAgreement(true);
  }

  return (
    <ScrollView contentContainerClassName="items-center bg-white1 p-4 lg:p-0">
      <View className="z-50 absolute top-0 right-0 m-8">
        <ButtonLogout />
      </View>
      <Logo className="m-4" />
      <View className="m-2">
        <Title text={t("onboarding/terms:title")} />
      </View>
      <View className="items-center w-full p-4 border border-solid border-gray rounded-md shadow lg:w-3/5 ">
        <iframe
          src="/termsofserviceizziwallet.pdf#toolbar=0"
          style={{ width: "100%", height: "60vh", border: "none" }}
          title="Terms of Use"
        />
      </View>
      <View className="flex-row items-center w-3/4 m-3">
        <CheckBox checked={check} onPress={toggle} color="#5D0CBA" />
        <Text className="text-justify text-darkergray px-3">
          Izzi Wallet is a financial technology company and is not a Money
          Service Business or a bank. All cash deposit services are provided by
          partner banks, Members FDIC. By creating an account at Izzi Wallet,
          you agree to Izzi Wallets Terms of Service, to all applicable laws and
          regulations, and agree that you are responsible for compliance with
          any and all applicable local laws.
        </Text>
      </View>
      <View className="flex-row items-center w-3/4 gap-2 m-3">
        <CheckBox
          checked={checkThirdPartiesAgreement}
          onPress={toggleThirdPartiesAgreement}
          color="#5D0CBA"
        />
        <Pressable
          onPress={() =>
            window.open(bridgeUrl, "_blank", "noopener noreferrer")
          }
        >
          <Text className="text-justify text-darkergray hover:text-blue5">
            {t("onboarding/terms:thirdparties")}
          </Text>
        </Pressable>
      </View>
      <Button
        label={t("common:button.nextstep")}
        onClick={handleSubmit(onSubmit)}
      />
      <Copyright />
      {isSubmitting && <Loader />}
    </ScrollView>
  );
}
